import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ActivityCondition} from "../../models/activity-condition";
import Helpers from "../../utils/helpers";

@Injectable()
export class ActivityConditionControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceActivityConditions(serviceId: string): Observable<ActivityCondition[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/activity_condition") as Observable<ActivityCondition[]>;
  }

  public getActivityCondition(activityConditionId: string): Observable<ActivityCondition> {
    return this.http.get(this.baseUrl + "activity_condition/" + activityConditionId) as Observable<ActivityCondition> ;
  }

  public createActivityCondition(serviceId: string, activityCondition: ActivityCondition) {
    Helpers.trimRecursiveObj(activityCondition);
    const body = JSON.stringify(activityCondition);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/activity_condition", body);
  }

  public saveActivityCondition<T>(activityCondition: ActivityCondition) {
    Helpers.trimRecursiveObj(activityCondition);
    const body = JSON.stringify(activityCondition);
    return this.http.put(this.baseUrl + "activity_condition", body, {responseType: "text"});
  }

  public deleteActivityCondition<T>(activityConditionId: string) {
    return this.http.delete(this.baseUrl + "activity_condition/" + activityConditionId, {responseType: "text"});
  }

}
